import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

/**@Components */
import Explore from "../shared/Explore";

/**@Icons */
import { FiLogOut } from "react-icons/fi";
import {
	toggleMobileExplore,
	toggleNav,
	toggleSignUp,
	toggleLogin,
	toggleLogoutModal,
} from "../../store/features/modalSlice";
export default function MobileNavigation({ handleLogout }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { openMobileExplore, openNav } = useSelector((state) => state.modal);
	const { user } = useSelector((state) => state.auth);
	const vendorId = localStorage.getItem("vendorId");

	const logoutTemplate = () => {
		return (
			<div
				className="flex items-items justify-between pe-2 text-[16px] font-bold"
				onClick={() => {
					handleLogout();
					dispatch(toggleNav());
					if (openMobileExplore) dispatch(toggleMobileExplore());
				}}
			>
				<span>Logout</span>
				<FiLogOut className="text-primary size-5" />
			</div>
		);
	};

	const protectedTopSidebarOptions = [
		{
			title: "List your venue",
			permission: !user && !vendorId,
			onClick: () => {
				navigate("/list-venues");
				dispatch(toggleNav());
			},
			className: "",
		},

		{
			title: "Login/Signup",
			permission: !user,
			onClick: () => {
				navigate("/login");
				dispatch(toggleNav());
			},
			className: "",
		},
		//
		// {
		// 	title: "Sign Up",
		// 	permission: !user,
		// 	onClick: () => {
		// 		navigate("/user-signup");
		// 	},
		// 	className: "",
		// },
		{
			title: "Notification",
			permission: false,
			onClick: () => {},
			className: "",
		},
		{
			title: "My Enquires",
			permission: !!user,
			onClick: () => {
				navigate("/enquiries");
				dispatch(toggleNav());
			},
			className: "",
		},
		{
			title: "My Favorites",
			permission: !!user,
			onClick: () => {
				navigate("/my-favorites");
				dispatch(toggleNav());
			},
			className: "",
		},
		{
			title: "My Profile",
			permission: !!user,
			onClick: () => {
				navigate("/profile");
				dispatch(toggleNav());
				if (openMobileExplore) dispatch(toggleMobileExplore());
			},
			className: "",
		},
		{
			title: "Logout",
			permission: !!user,
			// onClick: handleLogout,
			onClick: () => {
				handleLogout();
				dispatch(toggleNav());
				if (openMobileExplore) dispatch(toggleMobileExplore());
			},
			className: "",
		},
	];
	return (
		<div
			className={`lg:hidden fixed top-[4.8rem] right-0 z-40 w-full h-screen bg-white transition-transform ${
				openNav ? "-translate-x-0" : "-translate-x-full"
			}`}
		>
			<div className="w-full h-full p-8 text-primary flex flex-col gap-8 text-[16px] font-bold overflow-y-auto">
				<Explore />
				{protectedTopSidebarOptions.map((item, index) => {
					return (
						<>
							{item.permission && !item?.template && (
								<div className={item.className} onClick={item.onClick}>
									<p>{item.title}</p>
								</div>
							)}
						</>
					);
				})}
			</div>
		</div>
	);
}
